import { CartesianScaleOptions, ChartType, Plugin } from 'chart.js'
import { getCssVariable } from 'utils/app.ts'
import { YScaleTitleOptions } from 'components/charts/types.ts'

declare module 'chart.js' {
  // TType is unused here, but TypeScript requires the type parameters to be identical to the ones it augments
  interface PluginOptionsByType<TType extends ChartType> {
    yScaleTitle: YScaleTitleOptions
  }
}

export const yScaleTitle: Plugin<ChartType, YScaleTitleOptions> = {
  id: 'yScaleTitle',
  afterDraw: (chart, _, options) => {
    if (!options.labels) return

    const {
      ctx,
      chartArea: { top },
      scales
    } = chart

    const yScales = Object.entries(scales)
      .filter(([key]) => key.includes('y'))
      .map(([, value]) => value)

    yScales.forEach((scale) => {
      const label = options.labels[scale.id]
      const { display, ticks } = scale.options as CartesianScaleOptions
      if (!label || !display || !ticks?.display) return

      ctx.save()
      ctx.font = 'italic 500 12px "bolt-gelica"'
      ctx.fillStyle = getCssVariable('--text-subdued')
      ctx.fillText(label, scale.position === 'right' ? scale.right - scale.width - 2 : scale.left, top - 20)
      ctx.restore()
    })
  }
}
